const AUTH_STORAGE_KEYS = [
  "JWT",
  "email",
  "accessLevel",
  "orgCode",
  "organization",
  "department",
  "tenantId",
  "mainTenantId",
  "userName",
  "isFirstTimeUser",
];

const REMEMBER_ME_KEY = "rememberMe";
const PENDING_REMEMBER_ME_KEY = "pendingRememberMe";
const REMEMBERED_EMAIL_KEY = "rememberedEmail";
const REMEMBERED_PASSWORD_KEY = "rememberedPassword";

const hasValue = (value) =>
  value !== undefined && value !== null && value !== "";

export const getRememberMePreference = () =>
  localStorage.getItem(REMEMBER_ME_KEY) === "true";

export const getRememberedCredentials = () => {
  if (!getRememberMePreference()) {
    return { email: "", password: "" };
  }

  return {
    email: localStorage.getItem(REMEMBERED_EMAIL_KEY) || "",
    password: localStorage.getItem(REMEMBERED_PASSWORD_KEY) || "",
  };
};

export const clearSessionAuth = () => {
  AUTH_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));
};

export const clearPersistedAuthSession = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const clearRememberedCredentials = () => {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
  localStorage.removeItem(REMEMBERED_PASSWORD_KEY);
};

export const clearRememberedSession = () => {
  localStorage.removeItem(REMEMBER_ME_KEY);
  clearPersistedAuthSession();
  clearRememberedCredentials();
};

export const setPendingRememberMePreference = (rememberMe) => {
  sessionStorage.setItem(
    PENDING_REMEMBER_ME_KEY,
    rememberMe ? "true" : "false",
  );
};

export const consumePendingRememberMePreference = () => {
  const value = sessionStorage.getItem(PENDING_REMEMBER_ME_KEY) === "true";
  sessionStorage.removeItem(PENDING_REMEMBER_ME_KEY);
  return value;
};

export const persistRememberedCredentials = (credentials, rememberMe = false) => {
  if (!rememberMe) {
    localStorage.removeItem(REMEMBER_ME_KEY);
    clearRememberedCredentials();
    return;
  }

  const { email = "", password = "" } = credentials || {};

  localStorage.setItem(REMEMBER_ME_KEY, "true");

  if (email) {
    localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  } else {
    localStorage.removeItem(REMEMBERED_EMAIL_KEY);
  }

  if (password) {
    localStorage.setItem(REMEMBERED_PASSWORD_KEY, password);
  } else {
    localStorage.removeItem(REMEMBERED_PASSWORD_KEY);
  }
};

export const persistAuthSession = (values, rememberMe = false) => {
  clearSessionAuth();

  AUTH_STORAGE_KEYS.forEach((key) => {
    const value = values?.[key];

    if (!hasValue(value)) {
      if (rememberMe) {
        localStorage.removeItem(key);
      }
      return;
    }

    const normalizedValue = String(value);
    sessionStorage.setItem(key, normalizedValue);

    if (rememberMe) {
      localStorage.setItem(key, normalizedValue);
    }
  });

  if (rememberMe) {
    localStorage.setItem(REMEMBER_ME_KEY, "true");
    return;
  }

  clearRememberedSession();
};

export const restoreRememberedSession = () => {
  if (sessionStorage.getItem("JWT")) {
    return true;
  }

  if (!getRememberMePreference()) {
    return false;
  }

  const token = localStorage.getItem("JWT");
  if (!token) {
    return false;
  }

  AUTH_STORAGE_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      sessionStorage.setItem(key, value);
    }
  });

  return true;
};
